import "./style.css";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import {
  addData,
  auth,
  signUpUser,
} from "../../utils/firebase-config";
// Add this in your constants file, or replace with a string literal below
import { GOVERNMENT_OFFICER } from "../../utils/constants";

export default function RegistrationGovernmentOfficer(props) {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    organisation_name: "",
    office_address: "",
    rank: "",
    email: "",
    contact_number: "",
  });

  const [password, setPassword] = useState({
    password: "",
    confirmPassword: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handlePasswordChange = (e) => {
    const { name, value } = e.target;
    setPassword((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!password.password.trim() || !password.confirmPassword.trim()) {
      window.alert("Error: Please fill in all the required fields.");
      return;
    }
    if (password.password.trim() !== password.confirmPassword.trim()) {
      window.alert("Password and Confirm Password should be the same.");
      return;
    }

    const registrationForm = {
      ...formData,
      // If you didn’t add GOVERNMENT_OFFICER to constants, use: type: "GOVERNMENT_OFFICER"
      type: GOVERNMENT_OFFICER,
    };

    try {
      props.loadingStatus?.(true);
      const user = await signUpUser(registrationForm.email, password.password);

      if (user) {
        await addData(registrationForm);
        window.alert("You have registered as Government Officer.");
        navigate("/detail", { state: registrationForm });
      } else {
        // Sign up failed but no exception thrown
        window.alert("Error while registering user.");
      }
    } catch (err) {
      console.error(err);
      window.alert("Something went wrong during registration.");
    } finally {
      props.loadingStatus?.(false);
    }
  };

  return (
    <form className="registration-form-div" onSubmit={handleSubmit}>
      <div className="form-login">
        <div className="input-field">
          <label>Organisation Name</label>
          <input
            className="form-input"
            type="text"
            name="organisation_name"
            value={formData.organisation_name}
            onChange={handleInputChange}
            required
          />
        </div>

        <div className="input-field">
          <label>Office Address</label>
          <input
            className="form-input"
            type="text"
            name="office_address"
            value={formData.office_address}
            onChange={handleInputChange}
            required
          />
        </div>

        <div className="input-field">
          <label>Rank</label>
          <input
            className="form-input"
            type="text"
            name="rank"
            value={formData.rank}
            onChange={handleInputChange}
            required
          />
        </div>
              <div className="input-field">
          <label>Gender</label>
          <select
            className="form-input"
            id="gender"
            name="gender"
            value={formData.gender}
            onChange={handleInputChange}
            required
          >
            <option value="">Select Gender</option>
            <option value="male">Male</option>
            <option value="female">Female</option>
            <option value="other">Other</option>
          </select>
        </div>


        <div className="input-field">
          <label>Email</label>
          <input
            className="form-input"
            type="email"
            name="email"
            value={formData.email}
            onChange={handleInputChange}
            required
          />
        </div>

        <div className="input-field">
          <label>Phone Number</label>
          <input
            className="form-input"
            type="tel"
            name="contact_number"
            value={formData.contact_number}
            onChange={handleInputChange}
            required
          />
        </div>

        <div className="input-field">
          <label>Password</label>
          <input
            className="form-input"
            type="password"
            name="password"
            value={password.password}
            onChange={handlePasswordChange}
            required
          />
        </div>

        <div className="input-field">
          <label>Confirm Password</label>
          <input
            className="form-input"
            type="password"
            name="confirmPassword"
            value={password.confirmPassword}
            onChange={handlePasswordChange}
            required
          />
        </div>
      </div>

      <button className="submit-btn" type="submit">
        Register
      </button>
      <div style={{ height: "10px" }}></div>
    </form>
  );
}
